<template>
  <div class="space-y-6">
    <div>
      <h1 class="text-3xl font-bold tracking-tight">Access Token</h1>
      <p class="text-muted-foreground">
        Generate and manage your MCP access token for secure API integration.
      </p>
    </div>
    
    <TokenManager />
  </div>
</template>

<script setup lang="ts">
import TokenManager from '@/components/TokenManager.vue'
</script>

